import React from "react";
import { CDNImage } from "./cdn-image";
import { cn } from "~/lib/cn";

export interface TimeZoneItem {
  id?: string; // Auto-generated from city if not provided
  flagImage: string;
  timeRange: string;
  city: string;
}

export interface TimeZoneOverviewProps {
  title?: string;
  dateRange?: string;
  timeZones: TimeZoneItem[];
  className?: string;
}

const flagBaseUrl =
  "https://form-data.dreamcoachmatch.com/public/icons/countries";

export const TimeZoneOverview: React.FC<TimeZoneOverviewProps> = ({
  title = "Attend free via Zoom",
  dateRange,
  timeZones,
  className,
}) => {
  return (
    <div className={cn("w-full text-center py-8", className)}>
      {title && (
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-gray-900 mb-2">
          {title}
        </h2>
      )}

      {dateRange && <p className="text-gray-600 text-lg mb-8">{dateRange}</p>}

      <div className="flex flex-wrap justify-center gap-6 max-w-6xl mx-auto">
        {timeZones.map((zone, index) => (
          <div
            key={
              zone.id ||
              zone.city.toLowerCase().replace(/\s+/g, "-") ||
              `zone-${index}`
            }
            className="flex flex-col items-center space-y-3 p-4 rounded-lg hover:bg-gray-50 transition-colors min-w-[160px]"
          >
            <div className="flex items-center justify-center w-12 h-8">
              <CDNImage
                src={`${flagBaseUrl}/${zone.flagImage}`}
                alt={`${zone.city} flag`}
                width={32}
                height={32}
                className="object-cover rounded-full shadow-sm"
              />
            </div>

            <div className="text-center">
              <p className="font-semibold text-gray-900 text-sm">
                {zone.timeRange}
              </p>
              <p className="text-gray-600 text-sm">{zone.city}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
